import React from 'react';
import { useDrag } from 'react-dnd';

const Draggable: React.FC<{ text: string }> = ({ text }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'text',
    item: { type: 'text', text }, // Include the text in the drag data
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
        marginBottom: '10px',
        backgroundColor: 'lightblue',
        padding: '5px',
      }}
    >
      {text}
    </div>
  );
};

export default Draggable;
